/***************************************************************************/
"use client";
/***************************************************************************/

import * as React from "react";
import { cn } from "../../../utils/css";

const Form = ({
  className,
  ...props
}: React.FormHTMLAttributes<HTMLFormElement>) => (
  <form className={cn("flex flex-col gap-4", className)} {...props} />
);
Form.displayName = "Form";

export { Form };
